import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const formThemeShape = PropTypes.shape({
  horizontal: PropTypes.bool,
  gray: PropTypes.bool,
});
